export function addJustifiedLine(doc, text, x, y, maxWidth) {
  const words = text.trim().split(/\s+/)
  if (words.length === 1) {
    // если одно слово — просто печатаем слева
    doc.text(text, x, y)
    return
  }

  const lineWidth = doc.getTextWidth(text)
  const spaceCount = words.length - 1
  const extraSpace = (maxWidth - lineWidth) / spaceCount

  let cursor = x
  words.forEach((word, i) => {
    doc.text(word, cursor, y)
    if (i < words.length - 1) {
      cursor += doc.getTextWidth(word) + doc.getTextWidth(" ") + extraSpace
    }
  })
}

export function addJustifiedText(doc, text, x, y, maxWidth, lineHeight) {
  const lines = doc.splitTextToSize(text, maxWidth)
  lines.forEach((line, i) => {
    if (i === lines.length - 1) {
      // последняя строка — просто слева
      doc.text(line, x, y + i * lineHeight)
    } else {
      const words = line.split(" ")
      if (words.length === 1) {
        doc.text(line, x, y + i * lineHeight)
        return
      }
      const lineWidth = doc.getTextWidth(line)
      const spaceCount = words.length - 1
      const extraSpace = (maxWidth - lineWidth) / spaceCount

      let cursor = x
      words.forEach((word, w) => {
        doc.text(word, cursor, y + i * lineHeight)
        cursor += doc.getTextWidth(word) + doc.getTextWidth(" ") + extraSpace
      })
    }
  })
}
